<!-- 编辑 -->
<template>
  <div class="box">
    <!-- 路径 -->
    <div class="path">
      <img class="path_img" src="../../../../../assets/images/path.png"/>
      <div class="path_txt">运营管理系统 > 快应用报表 > 快应用投放 > 修改</div>
    </div>
    <!-- 编辑 -->
    <div class="work">
      <!--表单提交-->
      <el-form class="work_form" :model="formData" ref="formData" :rules="formRules" label-position="right" label-width="200px">
        <el-form-item label="应用：" prop="app_id">
          <el-select v-model="formData.app_id" filterable placeholder="请选择应用">
            <el-option
                    v-for="app in apps"
                    :key="parseInt(app.app_id)"
                    :label="'(' + app.app_id + ')' + app.app_name"
                    :value="parseInt(app.app_id)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="应用类型：" prop="app_type" v-if="formData.app_id && apps && apps.find(item => item.app_id==formData.app_id).business_line == 'quickapp'" required>
          <el-select v-model="formData.app_type" filterable placeholder="请选择应用类型">
            <el-option
                    v-for="key in Object.keys(appTypes)"
                    :key="parseInt(key)"
                    :label="'(' + key + ')' + appTypes[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道：" prop="channel_id">
          <el-select v-model="formData.channel_id" @change="loadChannelSlots" filterable placeholder="请选择应用">
            <el-option
                    v-for="item in channels"
                    :key="parseInt(item.channel_id)"
                    :label="'(' + item.channel_id + ')' + item.channel_name"
                    :value="parseInt(item.channel_id)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道位置：" prop="channel_slot_id">
          <el-select v-model="formData.channel_slot_id" filterable placeholder="请选择渠道位置">
            <el-option
                    v-for="item in channelSlots"
                    :key="parseInt(item.channel_slot_id)"
                    :label="'(' + item.channel_slot_id + ')' + item.channel_slot_name"
                    :value="parseInt(item.channel_slot_id)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="投放内容：" v-if="formData.app_id && apps && apps.find(item => item.app_id==formData.app_id).business_line == 'quickapp'">
          <el-select v-model="formData.measure_id" filterable clearable placeholder="请选择测评问题">
            <el-option
                    v-for="item in appraises"
                    :key="item.appraise_id"
                    :label="'(' + item.appraise_id + ')' + item.appraise_title"
                    :value="item.appraise_id">
            </el-option>
          </el-select>
          <el-tag>测评</el-tag>
          <br />
          <el-select v-model="formData.book_id" filterable clearable placeholder="请选择小说">
            <el-option
                    v-for="item in books"
                    :key="item.book_id"
                    :label="'(' + item.book_id + ')' + item.book_name"
                    :value="item.book_id">
            </el-option>
          </el-select>
          <el-tag>小说</el-tag>
          <br />
          <el-select v-model="formData.shortplay_id" filterable clearable placeholder="请选择短剧">
            <el-option
                    v-for="item in shortplays"
                    :key="item.shortplay_id"
                    :label="'(' + item.shortplay_id + ')' + item.shortplay_name"
                    :value="item.shortplay_id">
            </el-option>
          </el-select>
          <el-tag>短剧</el-tag>
          <br />
          <el-select v-model="formData.cookbook_id" filterable clearable placeholder="请选择菜谱">
            <el-option
                    v-for="key in Object.keys(cookbooks)"
                    :key="parseInt(key)"
                    :label="'(' + key + ')' + cookbooks[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
          <el-tag>菜谱</el-tag>
          <br />
          <el-select v-model="formData.health_class_id" filterable clearable placeholder="请选择养生分类">
            <el-option
                    v-for="key in Object.keys(health_classes)"
                    :key="parseInt(key)"
                    :label="'(' + key + ')' + health_classes[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
          <el-select v-model="formData.health_id" filterable clearable placeholder="请选择养生文章">
            <el-option
                    v-for="key in Object.keys(healthes)"
                    :key="parseInt(key)"
                    :label="'(' + key + ')' + healthes[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
          <el-tag>养生</el-tag>
          <br />
          <el-tag type="danger">请在测评、小说、短剧、菜谱、养生中仅选择其一</el-tag>
        </el-form-item>
        <el-form-item label="投放平台：" prop="issue_platform">
          <el-select v-model="formData.issue_platform" @change="changedIssuePlatforms" filterable placeholder="请选择投放平台">
            <el-option
                    v-for="item in issuePlatforms"
                    :key="item.issue_platform_tag"
                    :label="item.issue_platform_name"
                    :value="item.issue_platform_tag">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="投放流量：" prop="issue_flow" v-if="issueFlows && issueFlows.length >= 1">
          <el-select v-model="formData.issue_flow" filterable placeholder="请选择投放流量">
            <el-option
                    v-for="item in issueFlows"
                    :key="item.issue_flow_tag"
                    :label="item.issue_flow_name"
                    :value="item.issue_flow_tag">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="投放账号：" prop="issue_account" v-if="formData.issue_platform=='oppo' || formData.issue_platform=='vivo' || formData.issue_platform=='huawei' || formData.issue_platform=='toutiao' || formData.issue_platform=='kuaishou' || formData.issue_platform=='qtt' || formData.issue_platform=='gdt' || formData.issue_platform=='uc' || formData.issue_platform=='wifi' || formData.issue_platform=='alipay' || formData.issue_platform=='iqiyi' || formData.issue_platform=='weibo'">
          <el-input clearable v-model="formData.issue_account"></el-input>
        </el-form-item>
        <el-form-item label="投放账号KEY：" prop="issue_account_key" v-if="formData.issue_platform=='huawei' || formData.issue_platform=='wifi'">
          <el-input clearable v-model="formData.issue_account_key"></el-input>
        </el-form-item>
        <el-form-item label="投放回传KEY：" prop="oppo_api_key" v-if="formData.issue_platform=='wifi'">
          <el-input clearable v-model="formData.oppo_api_key"></el-input>
        </el-form-item>
        <el-form-item label="百度账号ID：" prop="issue_account" v-if="formData.issue_platform=='baidu'">
          <el-input clearable v-model="formData.issue_account"></el-input>
        </el-form-item>
        <el-form-item label="百度账号名称：" prop="issue_account_name" v-if="formData.issue_platform=='baidu'">
          <el-input clearable v-model="formData.issue_account_name"></el-input>
        </el-form-item>
        <el-form-item label="OPPO API-ID：" prop="oppo_api_id" v-if="formData.issue_platform=='oppo'">
          <el-input clearable v-model="formData.oppo_api_id"></el-input>
        </el-form-item>
        <el-form-item label="OPPO API-KEY：" prop="oppo_api_key" v-if="formData.issue_platform=='oppo'">
          <el-input clearable v-model="formData.oppo_api_key"></el-input>
        </el-form-item>
        <el-form-item label="百度 aKey：" prop="baidu_api_akey" v-if="formData.issue_platform=='baidu'">
          <el-input clearable v-model="formData.baidu_api_akey"></el-input>
        </el-form-item>
        <el-form-item label="VIVO 数据源：" prop="vivo_api_ds" v-if="formData.issue_platform=='vivo'">
          <el-input clearable v-model="formData.vivo_api_ds"></el-input>
        </el-form-item>

        <el-form-item label="投放帐户层级：" prop="issue_target" v-if="formData.issue_platform=='vivo'">
          <el-radio-group v-model="formData.issue_target">
            <el-radio v-model="formData.issue_target" :label="0">推广帐户</el-radio>
            <el-radio v-model="formData.issue_target" :label="1">推广计划</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="回传类型：" prop="issue_effect_type" v-if="issueEffects && issueEffects.length > 0">
          <el-select v-model="formData.issue_effect_type" @change="changedIssueEffect" filterable clearable placeholder="请选择效果数据回传类型">
            <el-option
                    v-for="item in issueEffects"
                    :key="item.issue_effect_tag"
                    :label="item.issue_effect_name"
                    :value="item.issue_effect_tag">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="应用配置场景：" prop="issue_cfg_scene" v-if="formData.app_id && apps && apps.find(item => item.app_id==formData.app_id).business_line == 'quickapp'">
          <el-select v-model="formData.issue_cfg_scene" filterable clearable placeholder="请选择应用配置场景">
            <el-option
                    v-for="key in Object.keys(issueCfgScenes)"
                    :key="parseInt(key)"
                    :label="issueCfgScenes[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="广告场景：" prop="issue_ad_scene" v-if="formData.app_id && apps && apps.find(item => item.app_id==formData.app_id).business_line == 'quickapp'">
          <el-select v-model="formData.issue_ad_scene" filterable clearable placeholder="请选择广告场景">
            <el-option
                    v-for="key in Object.keys(issueAdScenes)"
                    :key="parseInt(key)"
                    :label="issueAdScenes[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="打底广告场景：" prop="issue_ad_bidbase" v-if="(formData.issue_ad_scene==null || formData.issue_ad_scene=='') && formData.app_id && apps && apps.find(item => item.app_id==formData.app_id).business_line == 'quickapp'">
          <el-select v-model="formData.issue_ad_bidbase" filterable clearable placeholder="请选择打底广告场景">
            <el-option
                    v-for="key in Object.keys(adResourceBidbases)"
                    :key="parseInt(key)"
                    :label="adResourceBidbases[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="投放主体：" prop="issue_company" v-if="formData.issue_platform=='kuaishou' || formData.issue_platform=='toutiao'">
          <el-select v-model="formData.issue_company" filterable clearable placeholder="请选择投放主体">
            <el-option
                    v-for="key in Object.keys(issueCompanies)"
                    :key="parseInt(key)"
                    :label="issueCompanies[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
          &nbsp;&nbsp;
          <el-checkbox v-model="formData.is_ko">启用快手OPPO多拉</el-checkbox>
        </el-form-item>
        <el-form-item label="投放主体：" prop="issue_company" v-if="formData.issue_platform=='uc' || formData.issue_platform=='baidu'">
          <el-select v-model="formData.issue_company" filterable clearable placeholder="请选择投放主体">
            <el-option
                    v-for="key in Object.keys(issueUcCompanies)"
                    :key="parseInt(key)"
                    :label="issueUcCompanies[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
          <el-select v-model="formData.issue_domain" filterable clearable placeholder="请选择投放域名">
            <el-option
                    v-for="key in Object.keys(issueUcDomains)"
                    :key="parseInt(key)"
                    :label="issueUcDomains[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="投放产品：" prop="issue_product" v-if="formData.issue_platform=='wifi' || formData.issue_platform=='iqiyi' || formData.issue_platform=='kuaishou' || formData.issue_platform=='toutiao' || formData.issue_platform=='uc'">
          <el-select v-model="formData.issue_product" filterable clearable placeholder="请选择投放产品">
            <el-option
                    v-for="key in Object.keys(issueProducts)"
                    :key="parseInt(key)"
                    :label="issueProducts[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="落地页背景：" prop="issue_bg_campaign" v-if="formData.issue_platform=='oppo' || formData.issue_platform=='wifi' || formData.issue_platform=='uc' || formData.issue_platform=='kuaishou'">
          <el-select v-model="formData.issue_bg_campaign" filterable clearable placeholder="请选择落地页背景">
            <el-option
                    v-for="key in Object.keys(issueBgCampaigns)"
                    :key="parseInt(key)"
                    :label="issueBgCampaigns[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="投放H5链接：" prop="issue_h5_url">
          <el-input 
            type="textarea" 
            :rows="2"
            size="large"
            autosize 
            clearable 
            v-model="formData.issue_h5_url">
          </el-input>
        </el-form-item>
        <el-form-item label="投放Hap链接：" prop="issue_hap_url" v-if="formData.app_id && apps && apps.find(item => item.app_id==formData.app_id).business_line == 'quickapp'">
          <el-input 
            type="textarea" 
            :rows="2"
            size="large"
            autosize 
            clearable 
            readonly
            v-model="formData.issue_hap_url">
          </el-input>
        </el-form-item>
        <el-form-item label="投放点击监测链接：" prop="issue_tc_url">
          <el-input 
            type="textarea" 
            :rows="2"
            size="large"
            autosize 
            clearable 
            readonly
            v-model="formData.issue_tc_url">
          </el-input>
        </el-form-item>
        <el-form-item label="投放曝光监测链接：" prop="issue_tv_url">
          <el-input 
            type="textarea" 
            :rows="2"
            size="large"
            autosize 
            clearable 
            readonly
            v-model="formData.issue_tv_url">
          </el-input>
        </el-form-item>

        <el-form-item label="审核状态：" prop="approve_status" required>
          <el-radio-group v-model="formData.approve_status">
            <el-radio v-model="formData.approve_status" :label="2">通过</el-radio>
            <el-radio v-model="formData.approve_status" :label="1">不通过</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="投放状态：" prop="issue_status" required>
          <el-radio-group v-model="formData.issue_status">
            <el-radio v-model="formData.issue_status" :label="1">有效</el-radio>
            <el-radio v-model="formData.issue_status" :label="0">无效</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="回传状态：" prop="issue_debug" required>
          <el-radio-group v-model="formData.issue_debug">
            <el-radio v-model="formData.issue_debug" :label="1">调试状态</el-radio>
            <el-radio v-model="formData.issue_debug" :label="0">正常状态</el-radio>
          </el-radio-group>
        </el-form-item>
        
        <el-form-item label="授权人员：" prop="authorized_operators">
          <el-tag 
            style="margin-right:10px;"
            :key="operator.operator_id"
            v-for="operator in authorizeOperators"
            closable
            :disable-transitions="false"
            @close="removeAuthorizeOperator(operator)">
            {{operator.operator_name}}
          </el-tag>
          <el-select v-if="selectOperatorVisible" size="small" v-model="selectedOperatorId" @change="onSelectedOperator" filterable placeholder="请选择授权人员">
            <el-option
                    v-for="operator in availableOperators"
                    :key="operator.operator_id"
                    :label="operator.operator_name"
                    :value="operator.operator_id">
            </el-option>
          </el-select>
          <el-button v-else size="small" @click="showSelectOperator">+ 授权人员</el-button>
        </el-form-item>
        
        <el-form-item>
          <el-button class="btn_confirm" type="primary" @click="onGenerate">生成链接</el-button>
          <el-button class="btn_confirm" type="primary" @click="submitForm('formData')">保存</el-button>
          <el-button class="btn_cancel" @click="onCancel">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  getCurrDateTime
} from '../../../../../assets/scripts/date2string';

import {
  QuickAppConfig
} from '../../../../../assets/scripts/appconfig';

export default {
  data() {
    return {
      // 应用对象数据
      formData: { 
        app_id: null,
        app_type: null,
        issue_platform: null,
        issue_flow: null,
        channel_id: null,
        channel_slot_id: null,
        measure_id: null,
        book_id: null,
        shortplay_id: null,
        cookbook_id: null,
        health_class_id: null,
        health_id: null,
        issue_account: null,
        issue_account_name: null,
        issue_account_key: null,
        oppo_api_id: null,
        oppo_api_key: null,
        vivo_api_ds: null,
        baidu_api_akey: null,
        issue_effect_type: null,
        issue_cfg_scene: null,
        issue_ad_scene: null,
        issue_ad_bidbase: null,
        issue_company: null,
        issue_product: null,
        issue_domain: null,
        issue_bg_campaign: null,
        issue_h5_url: null,
        issue_hap_url: null,
        issue_tc_url: null,
        issue_tv_url: null,
        issue_time: null,
        issue_target: null,
        issue_debug: null,
        issue_status: null,
        approve_status: null,
        authorized_operators: null,
        is_ko: 0,
      },
      
      channels: null,         //渠道列表
      channelSlots: null,     //渠道位置

      measures: null,         //测评列表
      measureTemplets: null,  //测评模版映射表
      
      appraises: null,        //测评列表(新)
      appraiseTemplets: null, //测评模版映射表(新)

      books: null,            //小说
      bookNames: null,        //小说名称

      shortplays: null,       //短剧

      // 授权操作员列表
      authorizeOperators: [],

      // 投放平台、流量、效果数据回传
      issuePlatforms: null,
      issueFlows: null,
      issueEffects: null,

      // 有效操作员列表 
      availableOperators: [], 

      // 是否显示选择操作员
      selectOperatorVisible: false,  

      // 已选择操作员
      selectedOperatorId: null,

      // 应用
      apps: null,

      // 应用类型
      appTypes: {
        5: "H5",
        61: "OPPO",
        62: "VIVO",
        63: "小米",
        65: "华为",
      },
      
      // 菜谱
      cookbooks: {
        1:    '红烧肉',
        2:	  '排骨玉米汤',
        3:	  '鱼香肉丝',
        4:	  '炸酱面',
        5:	  '糖醋排骨',
        6:	  '可乐鸡翅',
        7:	  '红焖羊排萝卜',
        8:	  '木须肉',
        9:	  '酸辣土豆丝',
        10:	  '芒果圆子西米露',
        11:   '白菜豆腐煲',
        12:	  '油闷大虾',
        13:	  '煎蛋白菜豆腐汤',
        14:	  '照烧肥牛饭',
        15:   '东北锅包肉',
        16:   '家庭版葡式蛋挞',
        17:	  '秋葵',
        18:	  '三鲜饺子',
        19:	  '咖喱鸡肉饭',
        20:	  '酸辣汤',
        99999:'转盘'
      },

      // 健康养生
      healthes: {
        1:    '警惕亚健康，守护生命活力',
        2:	  '如何呵护颈椎健康',
        3:	  '如何远离腰椎问题',
        4:	  '关注 “工作病”，守护职场健康',
        5:	  '女性经期养生指南',
        6:	  '孕期养生指南',
        7:	  '老年人如何吃才健康？',
        8:	  '老年常见疾病如何预防？',
        9:	  '运动，让老人更健康的秘诀',
        10:	  '老年人觉少正常吗？',
        11:   '解压木鱼真的解压吗',
        12:	  '音乐如何助眠',
        13:	  '摆脱睡眠困扰',
        14:	  '冥想的妙用',
        15:   '冥想，减压神器',
        16:   '音乐，让睡眠更轻松',
        17:	  '常见食材的养生功效',
        18:	  '慢食文化与健康',
        19:	  '胶原蛋白的秘密',
        20:	  '食物搭配禁忌表',
        21:   '暖冬滋补秘籍',
        22:   '顺应节气，吃出健康',
        23:   '如何健康瘦？',
        24:   '八段锦古法养生',
        25:   '上班族如何保持日常运动',
        26:   '日常运动养生小技巧',
        27:   '瑜伽的好处',
        28:   '传统健身的养生智慧',
        29:   '选择合适的户外运动',
        30:   '科学健身',
      },

      health_classes: {
        0:    '食材养生',
        1:	  '冥想疗愈',
        2:	  '运动养生',
        3:	  '养生人群',
      },
      
      // 广告资源位打底广告场景
      adResourceBidbases: {
        1: '打底场景 1',
        2: '打底场景 2',
        3: '打底场景 3',
        4: '打底场景 4',
        5: '打底场景 5',
      },

      // 广告场景
      issueAdScenes: {
        1: '广告场景 1',
        2: '广告场景 2',
        3: '广告场景 3',
        4: '广告场景 4',
        5: '广告场景 5',
      },

      // 应用配置场景
      issueCfgScenes: {
        1: '配置场景1',
        2: '配置场景2',
        3: '配置场景3',
        4: '配置场景4',
        5: '配置场景5',
      },

      // 投放快手主体
      issueCompanies: {
         6: '黄冈市黄州区锦画百货店',
         7: '黄冈市黄州区梓樱百货店',
         8: '黄冈市黄州区暖语百货店',
         9: '黄冈市黄州区思梵百货店',
        10: '黄冈市黄州区谢忆昔百货店',
        11: '黄冈市黄州区琴旺庆百货店',
        12: '黄冈市黄州区梦璃百货店',
        15: '黄冈市黄州区鹿溪百货店',
        16: '黄冈市黄州区初醒心百货店',
        17: '黄冈市黄州区灵希百货店',
        18: '厦门晴弥乔溢网络有限公司',
				19: '厦门云期雨悠网络有限公司',
      },

      issueProducts: {
         9: '幸运猪',
				15: '爱测评',
        26: '爱生活',
				16: '肥猫免费测评',
				18: '肥猫小说',
				20: '飞猫免费小说',
        28: '胖猫免费测评',
      },

      // 投放UC主体
      issueUcCompanies: {
        1: '有礼（天津）网络有限公司',
        2: '万维感知（北京）科技有限公司',
        3: '天津肥猫科技有限公司',
        4: '万维智创（杭州）科技有限公司',
      },

      // 投放指定背景
      issueBgCampaigns: {
        1171: '壁纸',
        1174: '走路赚钱',
        1180: '天气',
        1181: '运动',
        1182: '养生',
        1183: '红包',
        9999: '菜谱',
        88888: '图书',
      },

      // 投放UC域名
      issueUcDomains: {
        1: 'coscdn.aiseeking.com',
        2: 'coscdn.ivknow.com',
        3: 'coscdn.uicats.com',
        4: 'coscdn.ivinno.com',
        5: 'coscdn.youlimeta.com',
        6: 'coscdn.irknow.com',
      },
      
      // 状态
      issueStatusMap: {
        1: "有效",
        0: "无效"
      },

      // 审核状态
      approveStatusMap: {
        0: "待审核",
        1: "审核不通过",
        2: "审核通过"
      },

      // 校验规则
      formRules: {
        app_id: [
          { required: true, message: '请选择应用', trigger: 'blur' }
        ],
        app_type: [
          { required: true, message: '请选择应用类型', trigger: 'blur' }
        ],
        issue_platform: [
          { required: true, message: '请选择投放平台', trigger: 'blur' }
        ],
        channel_id: [
          { required: true, message: '请选择渠道', trigger: 'blur' },
        ],
        channel_slot_id: [
          { required: true, message: '请输入渠道位置', trigger: 'blur' },
        ],
        issue_status: [
          { required: true, message: '请选择投放状态', trigger: 'blur' },
        ],
        approve_status: [
          { required: true, message: '请选择审核状态', trigger: 'blur' },
        ],
      },

      // 操作员对象
      operator: null,
    };
  },
  
  async created() {
    // 加载用户对象
    this.operator = JSON.parse(localStorage.getItem('operator'));
    // 加载原对象
    if(this.$route.params.app_issue_id) {
        this.formData = this.$route.params;
    }
    if(this.formData.issue_status==null || this.formData.issue_status==undefined) {
      this.formData.issue_status = 1;
    }
    if(!this.formData.approve_status) {
      this.formData.approve_status = 2;
    }
    if(this.formData.issue_debug==null || this.formData.issue_debug==undefined) {
      this.formData.issue_debug = 0;
    }
    if(this.formData.issue_target==null || this.formData.issue_target==undefined) {
      this.formData.issue_target = 0;
    }
    // 初始化数据
    await this.initApps();
    await this.initChannels();
    await this.initAppraises();
    await this.initBooks();
    await this.initShortplays();
    await this.initIssuePlatforms();
    await this.initOperators();
    await this.loadAuthorizeOperators(this.formData.app_issue_id);
    // 加载渠道位置
    if(this.formData.channel_id) {
      let channelSlotId = this.formData.channel_slot_id;
      await this.loadChannelSlots();
      if(channelSlotId) {
        this.formData.channel_slot_id = channelSlotId;
      }
    }
    // 加载发布流量和回传数据类型
    if(this.formData.issue_platform) {
      let issueFlow = this.formData.issue_flow;
      await this.loadIssueFlows();
      if(issueFlow) {
        this.formData.issue_flow = issueFlow;
      }

      let issueEffectType = this.formData.issue_effect_type;
      await this.loadIssueEffects();
      if(issueEffectType) {
        this.formData.issue_effect_type = issueEffectType;
      }
    }
  },
  
  methods: {
    // 初始化应用
    async initApps(){
      // 清空当前集合数据
      this.apps = null;
      // 调用接口
      let res = await this.$api.apiCommonApps();
      // 应用数据存进data
      this.apps = res.content;
    },

    // 初始化渠道
    async initChannels() {
      // 清空当前渠道
      this.channels = [];
      // 调用接口
      let res = await this.$api.apiCommonChannels();
      // 保存结果
      this.channels = res.content;
    },

    // 加载渠道位置
    async loadChannelSlots() {
      // 清空当前渠道
      this.formData.channel_slot_id = null;
      this.channelSlots = [];
      // 调用接口
      let res = await this.$api.apiQuickAppIssueChannelSlots({channelId: this.formData.channel_id, appIssueId: this.formData.app_issue_id});
      // 保存结果
      this.channelSlots = res.content;
    },

    // 初始化测评(新)
    async initAppraises() {
      // 清空当前测评
      this.appraises = null;
      // 调用接口
      let res = await this.$api.apiCommonAppraises();
      // 保存结果
      this.appraises = res.content;
      // 保存测评模版映射
      this.appraiseTemplets = {};
      this.appraises.forEach((appraise) => {
        this.appraiseTemplets[appraise.appraise_id] = appraise.templet_tag ? appraise.templet_tag : 'tpltxt_question';
      });
    },

    // 初始化小说
    async initBooks() {
      // 清空当前测评
      this.books = null;
      // 调用接口
      let res = await this.$api.apiCommonBooks();
      // 保存结果
      this.books = res.content;
      // 保存小说名称
      this.bookNames = {};
      this.books.forEach((book) => {
        this.bookNames[book.book_id] = book.book_name;
      });
    },
    
    // 初始化短剧
    async initShortplays() {
      // 清空当前短剧列表
      this.shortplays = null;
      // 调用接口
      let res = await this.$api.apiCommonShortplays();
      // 保存结果
      this.shortplays = res.content;
    },

    // 初始化发布平台
    async initIssuePlatforms() {
      // 清空当前渠道
      this.issuePlatforms = null;
      // 调用接口
      let res = await this.$api.apiCommonIssuePlatforms();
      // 保存结果
      this.issuePlatforms = res.content;
    },

    // 修改发布平台
    async changedIssuePlatforms() {
      this.loadIssueFlows();
      this.loadIssueEffects();
    },

    // 加载发布平台流量类型
    async loadIssueFlows() {
      // 清空当前流量类型
      this.formData.issue_flow = null;
      this.issueFlows = null;
      // 调用接口
      let res = await this.$api.apiCommonIssueFlows({issuePlatformTag: this.formData.issue_platform});
      // 保存结果
      this.issueFlows = res.content;
    },

    // 加载发布平台效果数据回传类型
    async loadIssueEffects() {
      // 清空当前流量类型
      this.formData.issue_effect_type = null;
      this.issueEffects = null;
      // 调用接口
      let res = await this.$api.apiCommonIssueEffects({issuePlatformTag: this.formData.issue_platform});
      // 保存结果
      this.issueEffects = res.content;
    },

    // 选择效果数据回传类型
    async changedIssueEffect() {
      this.$forceUpdate();
    },
    
    // 生成链接
    async onGenerate() {
      // 判断应用业务线
      if(!this.formData.app_id) {
        this.$message("请选择应用", "warning");
        return;
      }
      // 生成快应用链接
      if(this.apps.find(item => item.app_id == this.formData.app_id).business_line == 'quickapp') {
        this.onQuickappGenerate();
        return;
      }
      // 生成wechat h5 应用链接
      if(this.apps.find(item => item.app_id == this.formData.app_id).business_line == 'appraise_pay') {
        this.onWechatH5Generate();
        return;
      }
    },

    // 生成Wechat H5应用链接
    async onWechatH5Generate() {
      // 验证参数
      if(this.formData.issue_platform=='gdt' && !this.formData.issue_account) {
        this.$message("请先完善广点通投放账号信息", "warning");
        return;
      }
      // 设置应用类型
      this.formData.app_type = this.apps.find(item => item.app_id == this.formData.app_id).app_type;

      // 定义目标页面
      let sip = '';

      // 针对不同投放平台，生成监测链接
      if(this.formData.issue_platform=='gdt') {
        sip = 'tg';
        this.formData.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=gdt&advertiserid=__ACCOUNT_ID__&adid=__AD_ID__&creativeid=__DYNAMIC_CREATIVE_ID__&ip=__IP__&os=__DEVICE_OS_TYPE__&imei=__MUID__&oaid=__HASH_OAID__&reqid=__CLICK_ID__&reqtime=__CLICK_TIME__&referer=__CALLBACK__&rtaexp=__REQUEST_ID__&resolution=__IMPRESSION_ID__&userAgent=__USER_AGENT__';
        this.formData.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=gdt&advertiserid=__ACCOUNT_ID__&adid=__AD_ID__&creativeid=__DYNAMIC_CREATIVE_ID__&ip=__IP__&os=__DEVICE_OS_TYPE__&imei=__MUID__&oaid=__HASH_OAID__&reqid=__CLICK_ID__&reqtime=__CLICK_TIME__&referer=__CALLBACK__&rtaexp=__REQUEST_ID__&resolution=__IMPRESSION_ID__&userAgent=__USER_AGENT__';
      } else {
        sip = 'common';
        this.formData.issue_tc_url = '';
        this.formData.issue_tv_url = '';
      }

      // 基于应用，生成投放链接
      if(this.formData.app_id==23) {
        this.formData.issue_h5_url = 'https://coscdn.aiseeking.com/appraisepay/wh5/mbti/v3/index.html?sip=' + sip + '5&cid='+ this.formData.channel_id + '&csid=' + this.formData.channel_slot_id;
      }
    },

    // 生成快应用链接
    async onQuickappGenerate() {
      // 校验应用类型和投放平台是否一致
      if(this.formData.app_type==61 && !this.formData.issue_platform=='oppo'
          || this.formData.app_type==62 && !this.formData.issue_platform=='vivo') {
        this.$message("应用类型和投放平台不匹配", "warning");
        return;
      }
      if(this.formData.issue_platform=='oppo' && (!this.formData.issue_account || !this.formData.oppo_api_id || !this.formData.oppo_api_key)) {
        this.$message("请先完善OPPO投放账号信息", "warning");
        return;
      }
      if(this.formData.issue_platform=='vivo' && (!this.formData.issue_account || !this.formData.vivo_api_ds || !this.formData.issue_effect_type)) {
        this.$message("请先完善VIVO投放账号信息", "warning");
        return;
      }
      if(this.formData.issue_platform=='huawei' && (!this.formData.issue_account || !this.formData.issue_account_key)) {
        this.$message("请先完善华为投放账号信息", "warning");
        return;
      }
      if(this.formData.issue_platform=='toutiao' && (!this.formData.issue_account || !this.formData.issue_effect_type)) {
        this.$message("请先完善头条投放账号信息", "warning");
        return;
      }
      if(this.formData.issue_platform=='kuaishou' && !this.formData.issue_account) {
        this.$message("请先完善快手投放账号信息", "warning");
        return;
      }
      if(this.formData.issue_platform=='qtt' && !this.formData.issue_account) {
        this.$message("请先完善趣头条投放账号信息", "warning");
        return;
      }
      if(this.formData.issue_platform=='iqiyi' && !this.formData.issue_account) {
        this.$message("请先完善爱奇艺投放账号信息", "warning");
        return;
      }
      if(this.formData.issue_platform=='weibo' && !this.formData.issue_account) {
        this.$message("请先完善微博投放账号信息", "warning");
        return;
      }
      if(this.formData.issue_platform=='baidu' && (!this.formData.issue_account || !this.formData.issue_account_name || !this.formData.baidu_api_akey)) {
        this.$message("请先完善百度投放账号信息", "warning");
        return;
      }

      //if((this.formData.app_id==9 || this.formData.app_id==15 || this.formData.app_id==16) && (this.formData.measure_id==null || this.formData.measure_id=='')) {
      //  this.$message("测评投放需要选择测评问题", "warning");
      //  return;
      //}
      //if((this.formData.app_id==18) && (this.formData.book_id==null || this.formData.book_id=='')) {
      //  this.$message("小说投放需要选择小说", "warning");
      //  return;
      //}

      // 定义目标页面
      let target = '';
      let sip = '';

      // 针对不同投放平台，生成监测链接
      if(this.formData.issue_platform=='oppo') {
        target = 'oppo';
        sip = 'ou';
        this.formData.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=oppo&os=$os$&osVersion=$ov$&model=$m$&lang=$lan$&country=$c$&width=$w$&height=$h$&pkg=$pkg$&appVersion=$av$&userAgent=$ua$&referer=$rf$&net=$nt$&imei=$im$&oaid=__OAID__&adid=$ad$&adname=$an$&reqid=$req$';
        this.formData.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=oppo&os=$os$&osVersion=$ov$&model=$m$&lang=$lan$&country=$c$&width=$w$&height=$h$&pkg=$pkg$&appVersion=$av$&userAgent=$ua$&referer=$rf$&net=$nt$&imei=$im$&oaid=__OAID__&adid=$ad$&adname=$an$&reqid=$req$';
      } else if(this.formData.issue_platform=='vivo') {
        target = 'vivo';
        sip = 'vu';
        this.formData.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=vivo&os=__OS__&osVersion=__OSVERSION__&imei=__IMEI__&oaid=__OAID__&userAgent=__UA__&model=__MODEL__&lang=__LANG__&reqid=__REQUESTID__&net=__NETTYPE__&adname=__ADNAME__&ip=__IP__&location=__LOCATION__&oaidplain=__OAIDPLAIN__&androidid=__ANDROIDID__&reqtime=__REQUESTTIME__&advertiserid=__ADVERTISERID__&resolution=__RESOLUTION__&rtaexp=__RTAEXP__&adid=__ADID__&clickid=__CLICKID__&ts=__TS__';
        this.formData.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=vivo&os=__OS__&osVersion=__OSVERSION__&imei=__IMEI__&oaid=__OAID__&userAgent=__UA__&model=__MODEL__&lang=__LANG__&reqid=__REQUESTID__&net=__NETTYPE__&adname=__ADNAME__&ip=__IP__&location=__LOCATION__&oaidplain=__OAIDPLAIN__&androidid=__ANDROIDID__&reqtime=__REQUESTTIME__&advertiserid=__ADVERTISERID__&resolution=__RESOLUTION__&rtaexp=__RTAEXP__&adid=__ADID__&clickid=__CLICKID__&ts=__TS__';
      } else if(this.formData.issue_platform=='huawei') {
        target = 'huawei';
        sip = 'hw';
        this.formData.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=huawei';
        this.formData.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=huawei';
      } else if(this.formData.issue_platform=='qtt') {
        target = 'qtt';
        sip = 'qt';
        this.formData.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=qtt&os=__OS__&imei=__IMEIMD5__&width=__SCREEN_WIDTH__&height=__SCREEN_HEIGHT__&userAgent=__UA__&ip=__IP__&oaidplain=__OAID__&oaid=__OAIDMD5__&referer=__CALLBACK_URL__&ts=__TS__';
        this.formData.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=qtt&os=__OS__&imei=__IMEIMD5__&width=__SCREEN_WIDTH__&height=__SCREEN_HEIGHT__&userAgent=__UA__&ip=__IP__&oaidplain=__OAID__&oaid=__OAIDMD5__&referer=__CALLBACK_URL__&ts=__TS__';
      } else if(this.formData.issue_platform=='kuaishou') {
        target = 'ks';
        sip = 'ks';
        this.formData.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=kuaishou&advertiserid=__ACCOUNTID__&adid=__AID__&creativeid=__CID__&oaidplain=__OAID__&oaid=__OAID2__&imei=__IMEI2__&androidid=__ANDROIDID2__&os=__OS__&model=__MODEL__&ip=__IP__&referer=__CALLBACK__&userAgent=__UA__&ts=__TS__';
        this.formData.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=kuaishou&advertiserid=__ACCOUNTID__&adid=__AID__&creativeid=__CID__&oaidplain=__OAID__&oaid=__OAID2__&imei=__IMEI2__&androidid=__ANDROIDID2__&os=__OS__&model=__MODEL__&ip=__IP__&referer=__CALLBACK__&userAgent=__UA__&ts=__TS__';
      } else if(this.formData.issue_platform=='toutiao') {
        target = 'tt';
        sip = 'tt';
        this.formData.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=toutiao&advertiserid=__ADVERTISER_ID__&adid=__PROMOTION_ID__&adname=__PROMOTION_NAME__&ip=__IP__&os=__OS__&model=__MODEL__&imei=__IMEI__&oaid=__OAID_MD5__&oaidplain=__OAID__&userAgent=__UA__&androidid=__ANDROIDID__&ts=__TS__&reqid=__REQUEST_ID__&referer=__CALLBACK_PARAM__';
        this.formData.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=toutiao&advertiserid=__ADVERTISER_ID__&adid=__PROMOTION_ID__&adname=__PROMOTION_NAME__&ip=__IP__&os=__OS__&model=__MODEL__&imei=__IMEI__&oaid=__OAID_MD5__&oaidplain=__OAID__&userAgent=__UA__&androidid=__ANDROIDID__&ts=__TS__&reqid=__REQUEST_ID__&referer=__CALLBACK_PARAM__';
      } else if(this.formData.issue_platform=='gdt') {
        target = 'issue';
        sip = 'tg';
        this.formData.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=gdt&advertiserid=__ACCOUNT_ID__&adid=__ADGROUP_ID__&adname=__ADGROUP_NAME__&creativeid=__DYNAMIC_CREATIVE_ID__&location=__SITE_SET_NAME__&ip=__IP__&os=__DEVICE_OS_TYPE__&imei=__MUID__&oaid=__HASH_OAID__&reqid=__CLICK_ID__&reqtime=__CLICK_TIME__&referer=__CALLBACK__&rtaexp=__REQUEST_ID__&resolution=__IMPRESSION_ID__&userAgent=__USER_AGENT__';
        this.formData.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=gdt&advertiserid=__ACCOUNT_ID__&adid=__ADGROUP_ID__&adname=__ADGROUP_NAME__&creativeid=__DYNAMIC_CREATIVE_ID__&location=__SITE_SET_NAME__&ip=__IP__&os=__DEVICE_OS_TYPE__&imei=__MUID__&oaid=__HASH_OAID__&reqid=__CLICK_ID__&reqtime=__CLICK_TIME__&referer=__CALLBACK__&rtaexp=__REQUEST_ID__&resolution=__IMPRESSION_ID__&userAgent=__USER_AGENT__';
      } else if(this.formData.issue_platform=='alipay') {
        target = 'issue';
        sip = 'ap';
        this.formData.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=alipay&os=__OS__&ip=__IP__&imei=__IMEI__&oaid=__OAID_MD5__&model=__IDFA_MD5__&advertiserid=__PRINCIPAL_ID__&adid=__GROUP_ID__&creativeid=__AD_ID__&resolution=__CID__&rtaexp=__CAID__&androidid=__OPENID__&reqid=__REQUEST_ID__&ts=__TS__&reqtime=__ET__&referer=__CALLBACK_EXT_INFO__&userAgent=__UA__';
        this.formData.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=alipay&os=__OS__&ip=__IP__&imei=__IMEI__&oaid=__OAID_MD5__&model=__IDFA_MD5__&advertiserid=__PRINCIPAL_ID__&adid=__GROUP_ID__&creativeid=__AD_ID__&resolution=__CID__&rtaexp=__CAID__&androidid=__OPENID__&reqid=__REQUEST_ID__&ts=__TS__&reqtime=__ET__&referer=__CALLBACK_EXT_INFO__&userAgent=__UA__';
      } else if(this.formData.issue_platform=='baidu') {
        target = 'baidu';
        sip = 'bu';
        this.formData.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=baidu&callType=v2&referer=' + this.formData.baidu_api_akey + '&os=__OS__&resolution={{SIZE}}&oaidplain=__OAID__&oaid=__OAID_MD5__&imei=__IMEI_MD5__&ip=__IP__&userAgent=__UA__&androidid=__ANDROID_ID__&advertiserid=__USER_ID__&adid=__PLAN_ID__&creativeid=__IDEA_ID__&reqid=__CLICK_ID__&rtaexp=__EXT_INFO__&ts=__TS__';
        this.formData.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=baidu&callType=v2&referer=' + this.formData.baidu_api_akey + '&os=__OS__&resolution={{SIZE}}&oaidplain=__OAID__&oaid=__OAID_MD5__&imei=__IMEI_MD5__&ip=__IP__&userAgent=__UA__&androidid=__ANDROID_ID__&advertiserid=__USER_ID__&adid=__PLAN_ID__&creativeid=__IDEA_ID__&reqid=__CLICK_ID__&rtaexp=__EXT_INFO__&ts=__TS__';
      } else if(this.formData.issue_platform=='uc') {
        target = 'uc';
        sip = 'uc';
        this.formData.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=uc&advertiserid={ACID}&adid={AID}&creativeid={CID}&os={OS_ID}&model={MODEL1}&ip={IP}&oaid={OAID_SUM}&oaidplain={OAID}&imei={IMEI_SUM}&net={IMEI_SUM1}&referer={CALLBACK_URL}&userAgent={UA}&ts={UX_TS}';
        this.formData.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=uc&advertiserid={ACID}&adid={AID}&creativeid={CID}&os={OS_ID}&model={MODEL1}&ip={IP}&oaid={OAID_SUM}&oaidplain={OAID}&imei={IMEI_SUM}&net={IMEI_SUM1}&referer={CALLBACK_URL}&userAgent={UA}&ts={UX_TS}';
      } else if(this.formData.issue_platform=='wifi') {
        target = 'wifi';
        sip = 'wf';
        this.formData.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=wifi&advertiserid=__AID__&creativeid=__CID__&adid=__UID__&reqid=__SID__&reqtime=__STIME__&model=__MAC__&androidid=__ANDROID_ID__&imei=__IMEI__&os=__OS__&ip=__IP__&oaid=__HASH_OAID__&oaidplain=__OAID__&referer=__CALLBACK_URL__&userAgent=__UA__';
        this.formData.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=wifi&advertiserid=__AID__&creativeid=__CID__&adid=__UID__&reqid=__SID__&reqtime=__STIME__&model=__MAC__&androidid=__ANDROID_ID__&imei=__IMEI__&os=__OS__&ip=__IP__&oaid=__HASH_OAID__&oaidplain=__OAID__&referer=__CALLBACK_URL__&userAgent=__UA__';
      } else if(this.formData.issue_platform=='iqiyi') {
        target = 'iqiyi';
        sip = 'qy';
        this.formData.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=iqiyi&advertiserid=__ADVERTISER_ID__&creativeid=__CREATIVE_ID__&reqid=__IMPRESSS_ID__&androidid=__ANDROIDID__&os=__OS__&osVersion=__OS_VERSION__&model=__CELL_PHONE_MANUFACTURER__&net=__MAC__&ip=__IP__&oaid=__OAID_MD5__&oaidplain=__OAID__&imei=__IMEI__&referer=__CALLBACK_URL__&userAgent=__UA__&ts=__TS_MS__&rtaexp=__SIGN__';
        this.formData.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=iqiyi&advertiserid=__ADVERTISER_ID__&creativeid=__CREATIVE_ID__&reqid=__IMPRESSS_ID__&androidid=__ANDROIDID__&os=__OS__&osVersion=__OS_VERSION__&model=__CELL_PHONE_MANUFACTURER__&net=__MAC__&ip=__IP__&oaid=__OAID_MD5__&oaidplain=__OAID__&imei=__IMEI__&referer=__CALLBACK_URL__&userAgent=__UA__&ts=__TS_MS__&rtaexp=__SIGN__';
      } else if(this.formData.issue_platform=='weibo') {
        target = 'issue';
        sip = 'wb';
        this.formData.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=weibo&os=__OS__&osVersion=__OSVERSION__&ip=__IP__&net=__MAC1__&model=__MODEL__&lang=__SL__&imei=__IMEI__&oaid=__OAID_MD5__&androidid=__ANDROIDID__&advertiserid=__ADVERTISER_ID__&creativeid=__TSID__&adid=__AID__&adname=__AID_NAME__&referer=__CALLBACK_PARAM__&userAgent=__UA__&ts=__TS__';
        this.formData.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&target=weibo&os=__OS__&osVersion=__OSVERSION__&ip=__IP__&net=__MAC1__&model=__MODEL__&lang=__SL__&imei=__IMEI__&oaid=__OAID_MD5__&androidid=__ANDROIDID__&advertiserid=__ADVERTISER_ID__&creativeid=__TSID__&adid=__AID__&adname=__AID_NAME__&referer=__CALLBACK_PARAM__&userAgent=__UA__&ts=__TS__';
      } else {
        target = 'issue';
        sip = 'common';
        this.formData.issue_tc_url = '';
        this.formData.issue_tv_url = '';
      }
      
      // 针对不同应用类型生成链接
      if(QuickAppConfig[String(this.formData.app_id)]['type']=='app') {
        this.formData.issue_h5_url = 'https://' + (this.formData.issue_domain ? this.issueUcDomains[this.formData.issue_domain] : 'coscdn.' + QuickAppConfig[String(this.formData.app_id)]['domain'] + '.com') + QuickAppConfig[String(this.formData.app_id)]['path'] + QuickAppConfig[String(this.formData.app_id)]['name'] + '_' + target + '.html?sip=' + sip + '5&cid='+ this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + (this.formData.measure_id && this.formData.measure_id!='' ? '&mid=' + this.formData.measure_id + '&mtp=' + this.appraiseTemplets[this.formData.measure_id] : '') + (this.formData.book_id && this.formData.book_id!='' ? '&bid=' + this.formData.book_id + '&bnm=' + encodeURIComponent(this.bookNames[this.formData.book_id]) : '') + (this.formData.shortplay_id && this.formData.shortplay_id!='' ? '&vid=' + this.formData.shortplay_id : '') + (this.formData.cookbook_id && this.formData.cookbook_id!='' ? '&nid=' + this.formData.cookbook_id : '') + (this.formData.health_class_id!=undefined ? '&hcc=' + this.formData.health_class_id : '') + (this.formData.health_id && this.formData.health_id!='' ? '&hid=' + this.formData.health_id : '') + (this.formData.issue_company ? '&ic=' + this.formData.issue_company : '') + (this.formData.issue_bg_campaign ? '&il=' + this.formData.issue_bg_campaign : '') + (this.formData.issue_product ? '&io=' + this.formData.issue_product : '');
        this.formData.issue_hap_url = 'hap://app/' + QuickAppConfig[String(this.formData.app_id)]['pkg'] + '/pages/start?sip=' + sip + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&QUICK_APP_ST_CHANNEL=' + this.formData.channel_slot_id + (this.formData.measure_id && this.formData.measure_id!='' ? '&mid=' + this.formData.measure_id + '&mtp=' + this.appraiseTemplets[this.formData.measure_id] : '') + (this.formData.book_id && this.formData.book_id!='' ? '&bid=' + this.formData.book_id + '&bnm=' + encodeURIComponent(this.bookNames[this.formData.book_id]) : '') + (this.formData.shortplay_id && this.formData.shortplay_id!='' ? '&vid=' + this.formData.shortplay_id : '') + (this.formData.cookbook_id && this.formData.cookbook_id!='' ? '&nid=' + this.formData.cookbook_id : '') + (this.formData.health_class_id!=undefined ? '&hcc=' + this.formData.health_class_id : '') + (this.formData.health_id && this.formData.health_id!='' ? '&hid=' + this.formData.health_id : '');    
      } else if(QuickAppConfig[String(this.formData.app_id)]['type']=='game') {
        this.formData.issue_h5_url = 'https://' + (this.formData.issue_domain ? this.issueUcDomains[this.formData.issue_domain] : 'coscdn.' + QuickAppConfig[String(this.formData.app_id)]['domain'] + '.com') + QuickAppConfig[String(this.formData.app_id)]['path'] + QuickAppConfig[String(this.formData.app_id)]['name'] + '_' + target + '.html?sip=' + sip + '5&cid='+ this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + (this.formData.measure_id && this.formData.measure_id!='' ? '&mid=' + this.formData.measure_id + '&mtp=' + this.appraiseTemplets[this.formData.measure_id] : '') + (this.formData.book_id && this.formData.book_id!='' ? '&bid=' + this.formData.book_id + '&bnm=' + encodeURIComponent(this.bookNames[this.formData.book_id]) : '') + (this.formData.shortplay_id && this.formData.shortplay_id!='' ? '&vid=' + this.formData.shortplay_id : '') + (this.formData.cookbook_id && this.formData.cookbook_id!='' ? '&nid=' + this.formData.cookbook_id : '') + (this.formData.health_class_id!=undefined ? '&hcc=' + this.formData.health_class_id : '') + (this.formData.health_id && this.formData.health_id!='' ? '&hid=' + this.formData.health_id : '') + (this.formData.issue_company ? '&ic=' + this.formData.issue_company : '') + (this.formData.issue_bg_campaign ? '&il=' + this.formData.issue_bg_campaign : '') + (this.formData.issue_product ? '&io=' + this.formData.issue_product : '');
        let addition = {
          'sip': sip,
          'cid': this.formData.channel_id,
          'csid' : this.formData.channel_slot_id,
        };
        if(this.formData.issue_platform=='oppo') {
          this.formData.issue_hap_url = 'hap://game/' + QuickAppConfig[String(this.formData.app_id)]['pkg'] + '.nearme.gamecenter?userEntry=902&in_one_task=true&_GEOS_=' + encodeURIComponent(JSON.stringify(addition));
        } else {
          this.formData.issue_hap_url = 'hap://app/' + QuickAppConfig[String(this.formData.app_id)]['pkg'] + '.nearme.gamecenter?userEntry=902&in_one_task=true&_GEOS_=' + encodeURIComponent(JSON.stringify(addition));
        }
      } else {
        this.formData.issue_hap_url = '';
        this.formData.issue_hap_url = '';
      }
      
      // 针对快手，hap连接增加参数
      if(this.formData.issue_platform=='kuaishou') {
        this.formData.issue_hap_url = this.formData.issue_hap_url + '&reqid=__CALLBACK__';
        this.formData.issue_h5_url = this.formData.issue_h5_url + '&reqid=__CALLBACK__';
      }

      // 针对趣头条，hap链接增加参数
      if(this.formData.issue_platform=='qtt') {
        this.formData.issue_hap_url = this.formData.issue_hap_url + '&callbackurl=__CALLBACK_URL__';
        this.formData.issue_h5_url = this.formData.issue_h5_url + '&callbackurl=__CALLBACK_URL__';
      }

      // 针对vivo，hap链接增加参数
      if(this.formData.issue_platform=='vivo') {
        this.formData.issue_hap_url = this.formData.issue_hap_url + '&reqid=__REQUESTID__';
      }

      // 针对iqiyi，链接增加参数
      if(this.formData.issue_platform=='iqiyi') {
        this.formData.issue_hap_url = this.formData.issue_hap_url + '&reqid=__IMPRESSS_ID__';
        this.formData.issue_h5_url = this.formData.issue_h5_url + '&reqid=__IMPRESSS_ID__';
      }
      
      // 针对OPPO平台，H5链接增加参数
      if(this.formData.issue_platform=='oppo') {
        this.formData.issue_h5_url = this.formData.issue_h5_url + '&ownerId=' + this.formData.issue_account;
      }

      // 针对头条，链接增加reqid参数
      if(this.formData.issue_platform=='toutiao') {
        this.formData.issue_h5_url = this.formData.issue_h5_url + '&reqid=__CLICKID__';
      }
    },

    // 保存
    async submitForm(form) {
      // 验证表单数据
      this.$refs[form].validate((valid) => {
        if (valid) {
          // 显示页面加载
          const loading = this.$loading({
            lock: true,
            text: 'Processing ......',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
            target: '.box'
          });
          // 设置投放时间
          this.formData.issue_time = getCurrDateTime();
          // 广告场景空字符串处理
          this.formData.issue_ad_scene = this.formData.issue_ad_scene!='' ? this.formData.issue_ad_scene : null;
          if(this.formData.issue_ad_scene!=null) {
            this.formData.issue_ad_bidbase = null;
          }
          this.formData.issue_ad_bidbase = this.formData.issue_ad_bidbase!='' ? this.formData.issue_ad_bidbase : null;
          // 如果用户没有授权权限，自己创建的发布对象需要给自己授权
          if(this.operator && this.operator.permissions['10100500'] && this.operator.permissions['10100500'].indexOf('.authorize.')!=-1) {
            this.authorizeOperators.push({operator_id: this.operator.operatorId});
          }
          // 保存授权操作员集合
          if(this.authorizeOperators && this.authorizeOperators.length > 0) {
            let operatorIds = [];
            this.authorizeOperators.forEach(function(op) {
              operatorIds.push(op.operator_id);
            });
            this.formData.authorized_operators = operatorIds.join(',');
          }
          // 调用修改接口
          this.$api.apiQuickAppIssueUpdate(this.formData).then (res => {
            if (res.result === 1) {
              // 请求成功
              this.$message("修改快应用投放成功", "success");
              // 调用刷新广告资源
              this.refreshAdResources(this.formData.app_id, this.formData.app_type);
              // 回退
              this.$router.push('/running/luckystat/issue/index');
            } else {
              this.$message(res.message, "warning");
            }
          });
          // 关闭加载
          loading.close();    
        }
      });
    },

    // 刷新应用线上广告资源
    async refreshAdResources(appId, appType) {
      // 请求刷新
      let params = new Object();
      params['appId'] = appId;
      params['appType'] = appType;
      this.$api.apiRefreshAdResources(params);
    },

    // 取消
    async onCancel() {
      // 页面回退
      this.$router.go(-1); 
    },

    /**
     * 员工授权操作相关方法
     */ 

    // 初始化操作员
    async initOperators() {
      // 清空当前渠道
      this.availableOperators = [];
      // 调用接口
      let res = await this.$api.apiCommonOperators();
      // 保存结果
      this.availableOperators = res.content;
    },

    // 加载已授权操作员
    async loadAuthorizeOperators(appIssueId) {
      // 清空当前渠道
      this.authorizeOperators = [];
      // 调用接口
      let res = await this.$api.apiQuickAppIssueAuthorizes({appIssueId: appIssueId});
      // 保存结果
      this.authorizeOperators = res.content;
    },

    // 移除授权员工
    removeAuthorizeOperator(operator) {
      this.authorizeOperators.splice(this.authorizeOperators.indexOf(operator), 1);
    },

    // 显示选择操作员下拉框
    showSelectOperator() {
      this.selectedOperatorId = null;
      this.selectOperatorVisible = true;
    },

    // 选中一个操作员
    onSelectedOperator(operatorId) {
      // 验证选择有效性
      if(!operatorId) {
        return;
      }
      // 遍历可选操作员，定位到目标操作员
      let selectedOperator = null;
      this.availableOperators.forEach(function(operator) {
        if(operatorId==operator.operator_id) {
          selectedOperator = operator;
          return;
        }
      });
      // 遍历已授权操作员，如果重复不添加，如果不重复添加
      let repeated = false;
      this.authorizeOperators.forEach(function(operator) {
        if(selectedOperator.operator_id==operator.operator_id) {
          repeated = true;
          return;
        }
      });
      if(!repeated) {
        this.authorizeOperators.push(selectedOperator);
      }
      // 隐藏操作员选择框
      this.selectOperatorVisible = false;
    },
  },
};
</script>

<style lang='scss' scoped>
.box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-wrap: nowrap;
  align-items: center;
  overflow: auto;
}
.path {
  margin: 10px 5px 0px 15px;
  padding: 0px;
  width: 100%;
  height: 20px;
  color: rgb(6, 6, 31);
  font-size: 1rem;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
}
.path_img {
  margin-right: 5px;
  height: 15px;
  width: 15px;
}
.path_txt {
  width: 100%;
  height: 20px;
  text-align: left;
}
.work {
  margin: 10px 5px 10px 5px;
  padding: 10px 0px 20px 0px;
  width: 98%;
  height: calc(100% - 20px);
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-wrap: wrap;
  background: #fff;
  border-radius: 9px;
  align-items: center;
}
.work_form {
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.el-form-item {
  margin: 20px 5px 0px 15px;
  width: 96%;
  min-height: 38px;
  height: auto;
}
.el-input {
  width: 300px;
}
.el-select {
  width: 300px;
}
.el-button {
  width: 100px;
}
</style>